const { utils } = require('ethers');
const { keccak256, defaultAbiCoder } = utils;

const DOMAIN_SEPARATOR_VERSION = '1';

const getDomainSeparator = (contractAddress, contractName, chainID) => {
    return keccak256(
      defaultAbiCoder.encode(
        ['bytes32', 'bytes32', 'bytes32', 'uint256', 'address'],
        [
          keccak256(
            utils.toUtf8Bytes('EIP712Domain(string name,string version,uint256 chainId,address verifyingContract)')
          ),
          keccak256(utils.toUtf8Bytes(contractName)),
          keccak256(utils.toUtf8Bytes(DOMAIN_SEPARATOR_VERSION)),
          chainID,
          contractAddress
        ]
      )
    );
};

module.exports = {
    getDomainSeparator
};